if (!customElements.get('multicolumn-slider')) {
  customElements.define(
    'multicolumn-slider',
    class MulticolumnSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
          tabButtons: '.metaobject-tab-btn',
          cards: '.metaobject-card'
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
          activeTab: 'is-active',
          hiddenCard: 'is-hidden'
        };

        this.sectionId = this.dataset.sectionId;
        this.block = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items) || 3;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 3;
        this.laptopItems = parseInt(this.dataset.laptopItems) || this.items;
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        // Initialize Filter Tabs Behavior
        this.initTabs();

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        if (!this.sliderWrapper) return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 24;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.block.querySelector(this.selectors.nextEl),
            prevEl: this.block.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.block.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();
        }

        this.calcNavButtonsPosition();
      }

      destroySlider() {
        if (!this.sliderWrapper) return;
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        
        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance.slider) return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      initTabs() {
        const tabs = this.block ? this.block.querySelectorAll(this.selectors.tabButtons) : [];
        if (!tabs.length) return;

        tabs.forEach((tab) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();
            const filterValue = tab.getAttribute('data-filter');

            // Toggle active visual states
            tabs.forEach(t => t.classList.remove(this.classes.activeTab));
            tab.classList.add(this.classes.activeTab);

            // AUTO-CENTER LOGIC: Smoothly scroll clicked tab into horizontal focus center
            tab.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });

            this.filterItems(filterValue);
          });
        });
      }

      filterItems(filterValue) {
        const cards = this.querySelectorAll(this.selectors.cards);
        
        // Temporarily clear slider layout structure to sort items safely
        const sliderWasActive = typeof this.sliderInstance === 'object';
        if (sliderWasActive) {
          this.destroySlider();
        }

        cards.forEach((card) => {
          const cardCategory = card.getAttribute('data-category');
          if (filterValue === 'all' || cardCategory === filterValue) {
            card.classList.remove(this.classes.hiddenCard);
            if (sliderWasActive) card.classList.add('swiper-slide');
          } else {
            card.classList.add(this.classes.hiddenCard);
            if (sliderWasActive) card.classList.remove('swiper-slide');
          }
        });

        // Re-calculate slider instance configuration context if desktop carousel state is true
        if (sliderWasActive) {
          this.initSlider();
        }
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        // Uses your multicolumn image block class layout targets
        const firstMedia = this.querySelector('.multicolumn-card__image');
        const controls = this.block.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}